import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const KmTree = ({child, depth = 0, isExpand}) => {
  
  const hasChildren = child.children && child.children.length; // 다음 Depth가 존재하는지 체크 [boolean]
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    setIsActive(isExpand)
  }, [isExpand])

  return (
    <li>
      <div className="menuGrp" style={{paddingLeft: `${depth * 18}px`}}>
        {
          hasChildren ?
          <button type="button" className={`icofont-rounded-${isActive ? 'down' : 'right'}`} onClick={() => setIsActive(!isActive)}></button>
          :
          <span></span>
        }
        <Link to={`/develop/apis-manual/SFRT/${child.km_id}`}>
          {child.km_title}
        </Link>
      </div>

      {
        isActive &&
        <ul className={`depth_${depth}`}>
          {child.children?.map((child, i) =>
            <KmTree
              key={i}
              child={child}
              depth={depth + 1}
              isExpand={isExpand}
            />
          )}
        </ul>
      }
    </li>
  )
}

export default KmTree;